import { render, staticRenderFns } from "./BattleAcademiaHero.vue?vue&type=template&id=fc63e44e&"
import script from "./BattleAcademiaHero.vue?vue&type=script&lang=js&"
export * from "./BattleAcademiaHero.vue?vue&type=script&lang=js&"
import style0 from "./BattleAcademiaHero.vue?vue&type=style&index=0&id=fc63e44e&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports